<template>
  <div>
    <div v-for="(item, i) in items" :key="i">
      <v-btn class="w-full flex justify-start my-2" @click="onSubmit(item)">
        {{ item.title }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props:['items'],
  methods:{
    onSubmit(e){
      this.$emit("onPress", e)
    }
  }

};
</script>